<template>
  <view bindtap="toManagePassengers" class="container">
    <view class="info">
      <image class="user-icon" src="{{userIcon}}"></image>
      <view>常用乘车人</view>
    </view>
    <view class="entrance">
      <view wx:if="{{travelerNumber}}">{{travelerNumber}}位</view>
      <es-icon size="16" name="angle-right"></es-icon>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import store from '@/store'

  createComponent({
    data() {
      return {
        userIcon: 'https://ut-static.udache.com/webx/sfc/dywK-DylDYA4cT5g4T4m9.png'
      }
    },
    computed: {
      ...store.mapState({
        travelerListForLoginPage: 'contacts.travelerListForLoginPage',
      }),
      travelerNumber() {
        return this.travelerListForLoginPage.length || ''
      }
    },
    methods: {
      ...store.mapMutations({
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
      }),
      ...store.mapActions({
        updateTravelerListForLoginPage: 'contacts.updateTravelerListForLoginPage',
      }),
      toManagePassengers() {
        this.setMakeOrderLoginType(0)
        innerRouter.push(pagePath().CONTACTSELECT, {
          category: 'train',
          need_card: 1,
          manage: 1,
        })
      }
    },
    attached() {
      this.updateTravelerListForLoginPage()
    }
  })
</script>

<style lang='stylus' scoped>
.container
  border-radius 8px
  box-sizing border-box
  height 56px
  background #F8F9FD
  @extend .flex-center
  justify-content space-between
  padding 14px 8px 14px 16px
  margin-top 86px
  font-weight normal
  line-height 1
  letter-spacing 0px
  .info, .entrance
    @extend .flex-center
  .info
    font-family PingFangSC-Medium
    font-size 16px
    color #000000
    .user-icon
      width 28px
      height 28px
      margin-right 8px
  .entrance
    font-family PingFangSC-Regular
    font-size 12px
    color #666666
	
</style>

<script name='json'>
  module.exports = {
    component: true,
  }
</script>

